import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../lib/cn.js';
const FG = {
    warning: 'text-[var(--color-state-warning-fg)]',
    danger: 'text-[var(--color-state-danger-fg)]',
    info: 'text-[var(--color-state-info-fg)]',
    muted: 'text-[var(--color-text-muted)]',
};
const BORDERED = {
    warning: 'border-[var(--color-state-warning-fg)] bg-[var(--color-state-warning-bg)]',
    danger: 'border-[var(--color-state-danger-fg)] bg-[var(--color-state-danger-bg)]',
    info: 'border-[var(--color-state-info-fg)] bg-[var(--color-state-info-bg)]',
    muted: 'border-[var(--color-border-default)] bg-[var(--color-surface-sunken)]',
};
/**
 * Встроенное предупреждение рядом с тем, к чему оно относится: «у аккаунта нет
 * блока в конфиге», «исход возврата не подтверждён», «письмо уйдёт
 * немедленно». Не `ErrorCard` (та заменяет содержимое экрана) и не toast
 * (тот исчезает): строка остаётся на месте, пока верно то, о чём она говорит.
 *
 * До выноса одни и те же классы `text-xs text-[var(--color-state-warning-fg)]`
 * и рамка `rounded-md border … bg-[…-bg] px-3 py-2` были скопированы по
 * «Контенту», чарджбекам, диалогам и Telegram.
 */
export const InlineNotice = React.forwardRef(({ variant = 'warning', bordered, icon: Icon, as, className, children, ...props }, ref) => {
    const Tag = as ?? (bordered ? 'div' : 'p');
    const classes = bordered
        ? cn(Icon ? 'flex items-start gap-2' : null, 'rounded-md border', BORDERED[variant], 'px-3 py-2 text-xs', FG[variant], className)
        : cn('text-xs', FG[variant], className);
    return React.createElement(Tag, { ref, className: classes, ...props }, bordered && Icon ? (_jsxs(_Fragment, { children: [_jsx(Icon, { className: "mt-0.5 h-4 w-4 shrink-0", "aria-hidden": "true" }), children] })) : (children));
});
InlineNotice.displayName = 'InlineNotice';
//# sourceMappingURL=inline-notice.js.map